import { useEffect, useRef, useState } from "react";

export function useMultiSelectPanel() {
  const [open, setOpen] = useState(false);
  const [panelMinWidth, setPanelMinWidth] = useState<number>(0);

  // HTMLElement: the trigger renders as a div while an in-control search is open.
  const btnRef = useRef<HTMLElement | null>(null);
  const panelRef = useRef<HTMLDivElement | null>(null);

  /* measure trigger width */
  useEffect(() => {
    if (!open || !btnRef.current) return;

    const measure = () => setPanelMinWidth(btnRef.current!.offsetWidth);

    measure();

    const ro = new ResizeObserver(measure);
    ro.observe(btnRef.current);

    return () => ro.disconnect();
  }, [open]);

  /* outside click */
  useEffect(() => {
    const onDoc = (e: MouseEvent) => {
      if (
        !open ||
        panelRef.current?.contains(e.target as Node) ||
        btnRef.current?.contains(e.target as Node)
      ) {
        return;
      }

      setOpen(false);
    };

    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return {
    open,
    setOpen,
    btnRef,
    panelRef,
    panelMinWidth,
  };
}
